function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var createStObj = function createStObj(stObj, uniqueGroupServiceTypes) {
  var stChildren = stObj.children;
  var newStObj = _objectSpread(_objectSpread({}, stObj), {}, {
    children: []
  });
  stChildren.forEach(function (stChild) {
    uniqueGroupServiceTypes.forEach(function (ust) {
      if (ust === stChild.id) {
        newStObj.children.push(stChild);
      }
    });
  });
  return newStObj;
};
var transformServiceTypeArr = function transformServiceTypeArr(uniqueGroupServiceTypes) {
  var serviceTypesEnums = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var uniqueGroupSTObjects = [];
  serviceTypesEnums.forEach(function (st) {
    uniqueGroupServiceTypes.forEach(function (id) {
      if (st.id === id) {
        var newStObj = createStObj(st, uniqueGroupServiceTypes, serviceTypesEnums);
        uniqueGroupSTObjects.push(newStObj);
      }
    });
  });
  return uniqueGroupSTObjects;
};
var composeGroupServiceTypes = function composeGroupServiceTypes(programs) {
  var serviceTypesEnums = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var groupServiceTypes = programs
  // Some progams may be undefined.
  .filter(Boolean).map(function (program) {
    // Need to mutate for purpose of function.
    // eslint-disable-next-line no-param-reassign
    program.service_types = transformServiceTypeArr(program.provided_service_type_ids, serviceTypesEnums);
    return program.provided_service_type_ids;
  }).flat();
  var uniqueGroupServiceTypes = _toConsumableArray(new Set(groupServiceTypes));
  var serviceTypeObjArr = transformServiceTypeArr(uniqueGroupServiceTypes, serviceTypesEnums);
  return serviceTypeObjArr;
};
export default (function (groups) {
  var serviceTypesEnums = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return groups.map(function (group) {
    var _group$programs = group.programs,
      programs = _group$programs === void 0 ? [] : _group$programs;
    var newGroup = _objectSpread(_objectSpread({}, group), {}, {
      service_types: composeGroupServiceTypes(programs, serviceTypesEnums)
      // programs: composeGroupPrograms(programs, serviceTypesEnums),
    });
    return newGroup;
  });
});

// TODO: REWORK THIS... INTO ABOVE
function programServiceTypeMapHelper(program, serviceTypes) {
  var newProgram = _objectSpread({}, program);
  var programServiceTypes = program.provided_service_type_ids || program.relationships.services.data || [];
  newProgram.service_types = serviceTypes.filter(function (st) {
    var value = programServiceTypes.some(function (pst) {
      return st.id === (pst.id || pst);
    });
    return value;
  });
  newProgram.service_types = newProgram.service_types.map(function (pst) {
    var programServiceType = _objectSpread({}, pst);
    programServiceType.children = programServiceType.children.filter(function (cst) {
      var value = programServiceTypes.some(function (ast) {
        return cst.id === (ast.id || ast);
      });
      return value;
    });
    return programServiceType;
  });
  return newProgram;
}
export var composeProgramServiceTypes = function composeProgramServiceTypes(programs, serviceTypesEnums) {
  return programs.map(function (program) {
    return programServiceTypeMapHelper(program, serviceTypesEnums);
  });
};